import React from 'react';
import RouteMapItems from '../RouteMapItems/RouteMapItems';
import { useTaskRoutesMapItems } from './hooks/useTaskRoutesMapItems';

type Props = {};

const TaskRoutesMapItems: React.FC<Props> = () => {
  const {
    checkedRoutes,
    onFieldClick,
    checkedRouteIds,
    routeFields,
  } = useTaskRoutesMapItems();

  return (
    <RouteMapItems
      routes={checkedRoutes}
      onFieldClick={onFieldClick}
      checkedRouteIds={checkedRouteIds}
      routeFields={routeFields}
    />
  );
};

export default TaskRoutesMapItems;
